<div *nzModalTitle>
    {{nzModalData.title}}
</div>
<ng-template appDynamicTemplate></ng-template>